import { createSelector } from 'reselect';

import { getExtendedProductScopeUsOrGlobal } from '@discover-frontend/utils';
import { isEmpty } from '../utils/misc';

const currentCompany = (state) => state.myCompany.data;

export const getCurrentProductStreams = createSelector(
  [currentCompany],
  (currentCompany) => {
    if (currentCompany) {
      const product = currentCompany.products.find(
        (product) => product.slug === getExtendedProductScopeUsOrGlobal()
      );

      if (
        product &&
        product.extra_options &&
        !isEmpty(product.extra_options.sources)
      ) {
        return product.extra_options.sources;
      }
    }
    return [];
  }
);

export const getCurrentProductDataSources = createSelector(
  [currentCompany],
  (currentCompany) => {
    if (currentCompany) {
      const product = currentCompany.products.find(
        (product) => product.slug === getExtendedProductScopeUsOrGlobal()
      );

      if (
        product &&
        product.extra_options &&
        !isEmpty(product.extra_options.data_streams)
      ) {
        return product.extra_options.data_streams;
      }
    }
    return [];
  }
);
